
sap["ls"]["preload"]["UCF_HtmlIsland"] = function() {/* global _assert, _trace, _measure, START, STOP, INFO, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_BrowserWindow */
/// <reference path="../browser/BrowserWindow.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_DragAndDropDelegate */
/// <reference path="./delegates/DragAndDropDelegate.js"/>
/* global UCF_PlaceHolder */
/// <reference path="./base/PlaceHolder.js"/>

/**
 * A HtmlIsland control is a wrapper for custom HTML, JS, and CSS.
 *
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_HtmlIsland(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["UCF_HtmlIsland"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "HtmlIsland.js(27): UCF_HtmlIsland"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "HtmlIsland.js(28): UCF_HtmlIsland"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "HtmlIsland.js(29): UCF_HtmlIsland"); };

	UCF_PlaceHolder["apply"](this, [oDomRef, oLS]);
	this["bAllowTextSelection"] = true; // If switched off, no selection works inside custom HTML, even not in input fields
	this["oPublicEventRegistration"] = {}; // Event registrations (currently allowed: contextmenu)

	// If HtmlIsland is run as placeholder control with keepalive = true, an isolated area is required,
	// so events are not handled by lightspeed. However, for some events
	// like context menu, which occurs on window level, we still need to use lightspeed eventing (IsolatedAreaEvent)
	if (this["bKeepAlive"]) {
		this["oLS"]["addIsolatedArea"](oDomRef); // Do not handle events in lightspeed for HtmlIslands
	}
	this["oLS"]["oBrowserWindow"]["attachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["IsolatedAreaEvent"], this, "onisolatedareaevent");
};window["UCF_HtmlIsland"] = UCF_HtmlIsland; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_HtmlIsland"); UCF_HtmlIsland["_"] = {UCF_HtmlIsland: 0}; }; ;

UCF_HtmlIsland["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_PlaceHolder"))(); UCF_HtmlIsland.prototype["sClassName"] = "UCF_HtmlIsland";

/** Constructor
 * @private
 */
UCF_HtmlIsland["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["initialize"]++; }; 
	if (__UCF_MEASURE__) { UCF_Tracer.measure(START, "UCF_HtmlIsland.initialize"); };
	UCF_PlaceHolder.prototype["initialize"]["apply"](this, arguments);
	if (this["bKeepAlive"]) {
		// Placeholder has a fixed width, therefore we can set the Html Island <div> to 100%
		this["oDomRef"]["style"]["width"] = "100%";
		this["oDomRef"]["style"]["height"] = "100%";
	}

	var oMetaDomRef = UCF_DomUtil["$"](this["sId"] + "-meta");

	// If we use placeholder, the -meta info, where scripts are stored, might be in XMP area
	if (!oMetaDomRef && this["bKeepAlive"]) {
		oMetaDomRef = UCF_DomUtil["$"](this["sId"] + "-obj");
		if (oMetaDomRef) {
			var div = document["createElement"]("div");
			UCF_DomUtil["setInnerHtml"](div, oMetaDomRef["innerHTML"]); // convert content of XMP into nodes
			// Find control element in XMP
			oMetaDomRef = UCF_DomUtil["firstChild"](div);
			while (oMetaDomRef) {
				if (oMetaDomRef["getAttribute"]("id") === this["sId"]) break;
				oMetaDomRef = UCF_DomUtil["nextSibling"](oMetaDomRef);
			}
			if (oMetaDomRef) {
				// Find -meta element in XMP
				oMetaDomRef = UCF_DomUtil["firstChild"](oMetaDomRef);
				while (oMetaDomRef) {
					if (oMetaDomRef["getAttribute"]("id") === (this["sId"] + "-meta")) {
						break;
					}
					oMetaDomRef = UCF_DomUtil["nextSibling"](oMetaDomRef);
				}
			}
			div = null;
		}
	}

	var sStyleScriptJSON = oMetaDomRef ? UCF_DomUtil["sGetInnerText"](oMetaDomRef) : null;

	if (sStyleScriptJSON) {
		// Content of oMetaDomRef is JSON serialized scripts and styles. Extract them...
		var oPage = this["oLS"]["oGetPageInternal"](),
			oScriptsStyles = {},
			oEntry = {};

		try {
			oScriptsStyles = UCF_JsUtil["oJsonParse"](sStyleScriptJSON);
		} catch (e) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "Cannot convert " + sStyleScriptJSON + " to JSON Object in HTMLIsland " + this["sId"], "HtmlIsland.js(97): initialize"); };
		}
		// .. and add them to the page
		while (oScriptsStyles["styles"] && oScriptsStyles["styles"]["length"] > 0) {
			oEntry = oScriptsStyles["styles"]["shift"]();
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Adding style with src="' + oEntry["src"] + '", content="' + oEntry["content"] + '"', "HtmlIsland.js(102): initialize"); };
			if (oPage)
				oPage["addStyle"](oEntry["src"], oEntry["content"]);
		}

		while (oPage && oScriptsStyles["scripts"] && oScriptsStyles["scripts"]["length"] > 0) {
			oEntry = oScriptsStyles["scripts"]["shift"]();
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Adding script with src="' + oEntry["src"] + '", content="' + oEntry["content"] + '"', "HtmlIsland.js(109): initialize"); };
			oPage["addScript"](oEntry["src"], oEntry["content"], oEntry["customAttributes"]);
		}
	}
	// Remove node so next time we get it fresh
	if (oMetaDomRef && oMetaDomRef["parentNode"]) {
		oMetaDomRef["parentNode"]["removeChild"](oMetaDomRef);
	}

	/*
	 * lock and unlock could be passed to the application
	 */
	//this.attachLSEvent(this.oLS.E_EVENTS.Lock, "lock");
	//this.attachLSEvent(this.oLS.E_EVENTS.Unlock, "unlock");
};;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["initialize"] = 0; };

/** Destructor
 * @private
 */
UCF_HtmlIsland["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["destroy"]++; }; 
	if (__UCF_MEASURE__) { UCF_Tracer.measure(START, "UCF_HtmlIsland.destroy"); };

	if (this["sTimerId"]) UCF_JsUtil["clearDelayedCall"](this["sTimerId"]);

	// Application can register a unload/destroy call, execute it now
	if (this["sUnLoad"]) {
		UCF_JsUtil["eval"](this["sUnLoad"]);
	}

	// eslint-disable-next-line @ur/no-memory-leaks
	this["oDragAndDropDelegate"] = null;
	this["oLS"]["oBrowserWindow"]["detachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["IsolatedAreaEvent"], this, "onisolatedareaevent");
	this["removeAllEventListeners"]();
	this["oPublicEventRegistration"] = null;
	/*
	 * lock and unlock could be passed to the application
	 */
	//	this.detachLSEvent(this.oLS.E_EVENTS.Lock, "lock");
	//	this.detachLSEvent(this.oLS.E_EVENTS.Unlock, "unlock");
	UCF_PlaceHolder.prototype["destroy"]["apply"](this, arguments);
	if (__UCF_MEASURE__) { UCF_Tracer.measure(STOP, "UCF_HtmlIsland.destroy", "HtmlIsland " + this["sId"] + " destroyed  "); };
};;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["destroy"] = 0; };

/**
 * @public
 * @return {boolean} whether it is alive
 * @see UCF_PlaceHolder
 */
UCF_HtmlIsland["prototype"]["bDoKeepAlive"] = function() {;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["bDoKeepAlive"]++; }; 
	return (this["bKeepAlive"] && UCF_DomUtil["$"](this["sId"] + "-ph")) ? true : false;
};;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["bDoKeepAlive"] = 0; };

/**
 * set a handler for drag and drop processing
 * @public
 * @param {UCF_DragAndDropHandler} oDragAndDropHandler a drag and drop handler implementing lsdragstart, lsdrag, lsdragover, lsdraghover, lsdragscroll, lsdrop, lsdragend, lsdragenter, lsdragleave,
 */
UCF_HtmlIsland["prototype"]["setDragAndDropHandler"] = function(oDragAndDropHandler) {;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["setDragAndDropHandler"]++; }; 

	if (this["oDragAndDropDelegate"])
		this["removeDelegate"](this["oDragAndDropDelegate"]);

	if (!oDragAndDropHandler)
		return;

	this["oDragAndDropDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_DragAndDropDelegate"))(oDragAndDropHandler);
	this["addDelegate"](this["oDragAndDropDelegate"]);
};;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["setDragAndDropHandler"] = 0; };

/**
 * HtmlIsland is an isolated area, however, events that occur on window level (like context menu)
 * should also be available to the island developer.
 * @public
 * @param {UCF_Event} oEvent browser event
 */
UCF_HtmlIsland["prototype"]["onisolatedareaevent"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["onisolatedareaevent"]++; }; 
	var oBrowserEvent = oEvent["mParameters"]["oBrowserEvent"];

	if (!this["oPublicEventRegistration"] || !this["oPublicEventRegistration"][oEvent["mParameters"]["type"]] || !UCF_DomUtil["bContains"](this["oDomRef"], oBrowserEvent["oSource"])) {
		// No registration for this event or event does not belong to this instance of isolated area
		if (oEvent["mParameters"]["type"] === "contextmenu" && typeof(oBrowserEvent["bContinue"]) === "undefined") {
			// For the context menu event, we trigger the normal behavior
			oBrowserEvent["bContinue"] = true;
		}
		return;
	}

	var aRegistrations = this["oPublicEventRegistration"][oEvent["mParameters"]["type"]];
	for (var i = 0, max = aRegistrations["length"]; i < max; i++) {
		aRegistrations[i](oBrowserEvent["oDomEvent"]);
	}
	if (!oBrowserEvent["oDomEvent"]["cancelBubble"]) {
		// If the island developer does not cancelBubble, we continue with the normal behavior ...
		oBrowserEvent["bContinue"] = true;
	} else {
		// ... otherwise we stop processing
		oBrowserEvent["bContinue"] = false;
	}
};;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["onisolatedareaevent"] = 0; };

UCF_HtmlIsland["prototype"]["addEventListener"] = function(sName, fHandler) {;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["addEventListener"]++; }; 
	if (!sName || !fHandler || typeof fHandler !== "function" || !this["oDomRef"]) {
		return;
	}

	// Currently we only support to add event handler for "contextmenu". More event registrations may follow
	if (sName !== "contextmenu") {
		return;
	}

	if (!this["oPublicEventRegistration"][sName]) {
		this["oPublicEventRegistration"][sName] = [];
	}
	// Add the registration
	this["oPublicEventRegistration"][sName]["push"](fHandler);
};;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["addEventListener"] = 0; };

UCF_HtmlIsland["prototype"]["removeEventListener"] = function(sName, fHandler) {;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["removeEventListener"]++; }; 
	if (!this["oPublicEventRegistration"] || !sName || !this["oPublicEventRegistration"][sName] || !fHandler || typeof fHandler !== "function") {
		return;
	}

	var aRegistrations = this["oPublicEventRegistration"][sName];

	// Remove event registration.
	// (The first that occurs for given event name and function. If multiple are registered, this needs to be done multiple times as well)
	var i = aRegistrations["indexOf"](fHandler);
	if (i !== -1) {
		aRegistrations["splice"](i, 1);
	}

	if (this["oPublicEventRegistration"][sName]["length"] === 0) {
		this["oPublicEventRegistration"][sName] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["removeEventListener"] = 0; };

UCF_HtmlIsland["prototype"]["removeAllEventListeners"] = function() {;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["removeAllEventListeners"]++; }; 
	for (var sName in this["oPublicEventRegistration"]) {
		this["oPublicEventRegistration"][sName] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["removeAllEventListeners"] = 0; };

UCF_HtmlIsland["prototype"]["applyFocusInfo"] = function(oFocusInfo) {;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["applyFocusInfo"]++; }; 
	// Focus could lead to troubles with custom context menues
	// However, we could let the HtmlIsland custom code register
	// on focus event
};;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["applyFocusInfo"] = 0; };

// lock and unlock could be passed to the application
/*
UCF_HtmlIsland.prototype.lock = function(oEvent) {
};

UCF_HtmlIsland.prototype.unlock = function(oEvent) {
};
*/

/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_HtmlIsland["prototype"]["aAttributeNames"] = ["sId","sUnLoad","sVisibility","sLifeCycle","sCustomData","sLabelledBy","sTooltip","sAccessibilityDescription"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_HtmlIsland["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_HtmlIsland["prototype"]["aMethodNames"] = ["setDragAndDropHandler","setKeepAlive","addEventListener","removeEventListener","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_HtmlIsland["prototype"]["sId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_HtmlIsland["prototype"]["sUnLoad"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_HtmlIsland["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.LifeCycle}
 */
UCF_HtmlIsland["prototype"]["sLifeCycle"] = "BROWSER";

/**
 * @private
 * @type {string}
 */
UCF_HtmlIsland["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_HtmlIsland["prototype"]["sLabelledBy"] = '';

/**
 * @private
 * @type {string}
 */
UCF_HtmlIsland["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {string}
 */
UCF_HtmlIsland["prototype"]["sAccessibilityDescription"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_HtmlIsland["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["setDefaultValues"]++; }; 
	this["sId"] = '';
	this["sUnLoad"] = '';
	this["sVisibility"] = "VISIBLE";
	this["sLifeCycle"] = "BROWSER";
	this["sCustomData"] = '';
	this["sLabelledBy"] = '';
	this["sTooltip"] = '';
	this["sAccessibilityDescription"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Id", '', true);
		this["setClientProperty"]("UnLoad", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("LifeCycle", "BROWSER", true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("LabelledBy", '', true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("AccessibilityDescription", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

UCF_HtmlIsland.prototype["aPublicMethods"] = ["bDoKeepAlive","setDragAndDropHandler","onisolatedareaevent"].concat(UCF_HtmlIsland.prototype.aPublicMethods || []);
};